import { Deck, Rules } from "engine/CardPakTypes";

import { Tile } from "../Tiles.model";
import { Decimal } from "decimal.js";

export interface DianXinDeck extends Deck {
  cards: Tile[];
}

export interface DianXinPlayerParams {
  closedHand: Tile[];
  openHand: { [key: string]: Tile[] }[];
  playedTiles: Tile[];
  gamePoints: Decimal;
  skipped: boolean;
  winner: boolean;
}

export interface InitializedPlayerParam extends DianXinPlayerParams {
  id: string;
  name: string;
}

export interface DianXinGameParams {
  wall: Tile[];
  deadWall: Tile[];
  lastPlay: { by: string; card: Tile } | null;
  finishAnimationToShow: string;
  showPrizeHorseSelection: boolean;
}

export interface DianXinRules extends Rules {
  gameParams: DianXinGameParams;
  playerParams: DianXinPlayerParams;
}

export enum ClaimReason {
  PENG = "peng",
  ANGANG = "angang",
  ADDGANG = "addgang",
  GANG = "gang",
  CHI = "chi",
  HU = "hu",
}
